import styled from "@emotion/styled";

import { MDSSelectMenuWithContent } from "@/mds";

// Matches the facet filters in `components/filters`, which cap their menus at
// 50vh so a long option list scrolls instead of running off the screen.
export const StyledSelectMenu = styled(MDSSelectMenuWithContent)`
  min-width: 176px;
  max-width: 320px;
  max-height: 50vh;
`;
